import { render, staticRenderFns } from "./branchLibraryItem.vue?vue&type=template&id=492f0cc0&scoped=true&"
import script from "./branchLibraryItem.vue?vue&type=script&lang=js&"
export * from "./branchLibraryItem.vue?vue&type=script&lang=js&"
import style0 from "./branchLibraryItem.vue?vue&type=style&index=0&id=492f0cc0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f0cc0",
  null
  
)

component.options.__file = "branchLibraryItem.vue"
export default component.exports